import React, { useEffect, useState} from 'react';
import {CancelEventSend, Result} from "../interfaces";
import {cancelEventRSVP} from "../DAL/data-service";
import {getIsChina} from "../../../domain/hidden-data-provider";
import {createControl} from "../../../domain/validation/validation";
import {getSimpleCaptchaValidationError} from "../../../domain/captcha/simple-captcha";
import {IFormControl} from "../../../ui/forms/interfaces";
import {
    getRecaptcha2Error,
    getRecaptchaToken,
    renderRecaptcha2,
    resetRecaptcha2
} from "../../../domain/captcha/recaptcha-provider";
import ChinaCaptchaField from "../../../ui/forms/fields/captcha-china-field";
import Recaptcha3Text from "../../../domain/captcha/recaptcha3-terms";
import {getJSONFromHtml} from "../../../domain/common";
import Preloader from "../../../ui/svg/common/preloader";
interface IEventsCancelProps {
    message: string | null,
}

/**
 * the entry point
 */
const EventsCancelApp= (props: IEventsCancelProps) => {
    const isChina = getIsChina();

    // validation ---------------------------------------

    const simpleCaptchaControl = createControl('simpleCaptcha', '', {
        required: true,
        requiredMessage: getSimpleCaptchaValidationError(),
        length: 5,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [ResultData, setResultData] = useState<Result>();
    /*const [email, setEmail] = useState<IFormControl>(emailControl);*/

    // simple captcha - used for china
    const [simpleCaptchaCode, setSimpleCaptchaCode] = useState<IFormControl>(simpleCaptchaControl);
    const [simpleCaptchaAttempts, setSimpleCaptchaAttempts] = useState(0);

    // google recaptcha version 2 & 3
    const [recaptchaVersion, setRecaptchaVersion] = useState(3);
    const [recaptcha2WidgetID, setRecaptcha2WidgetID] = useState(0);

    // captcha: common
    const [captchaError, setCaptchaError] = useState('');

    /**
     * load initial data (drop-downs content) on page load once
     */
    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();
    }, []);

    /**
     * handle changes
     */
    const cancelReg = async () => {
        setIsLoading(true);
        const captchaToken = !isChina ? await getRecaptchaToken(recaptchaVersion) : simpleCaptchaCode.value;

        if(!captchaToken){
            setCaptchaError(isChina ? getSimpleCaptchaValidationError() : getRecaptcha2Error());
            setIsLoading(false);
            return;
        }

        const isSubEventStr = getJSONFromHtml(document.getElementById('is-sub-event'));
        const eventRSVPGuid = window.location.pathname.split("/").pop();
        const cancelEventSend: CancelEventSend = {
            action:'cancel',
            rSVP_GUID:eventRSVPGuid,
            isSubEvent: (isSubEventStr === "true"),
            captchaCode: captchaToken,
            recaptchaVersion: recaptchaVersion
        }
        //console.log('cancelEventSend: ',cancelEventSend);
        const response = await cancelEventRSVP(cancelEventSend);

        setIsLoading(false);
        if(!response || response.statusCode !== 200) {
            //setError(response.data as unknown as ModelServerErrors);
            return;
        }

        //------------------------------------------------------------------------recaptcha-error
        if(isChina){

            // re-render simple captcha
            setSimpleCaptchaAttempts(simpleCaptchaAttempts + 1);
        }
        else{
            if(response?.data.resultObjectType === 'recaptcha-error') {
                setRecaptchaVersion(2);
                renderCaptcha2Fallback();
            }

            if(recaptchaVersion === 2){
                resetRecaptcha2();
            }
        }

        console.log('response.data:',response.data);
        //------------------------------------------------------------------------REDIRECT if success
        if(response.data.resultObjectType === "CANCELRSVP_SUCCESS")
            setResultData(response.data);


        if(response.data.resultObjectType === "REFRESH") {
            window.location.reload();
            return;
        }

        //------------------------------------------------------------------------Error message
        if(response.data.resultStatus === false && response.data.message !== '')
            setResultData(response.data);
        //console.log('response.data: ',response.data);
    };
    /**
     * if recaptcha 3 returns low score (the limit is defined in kentico settings),
     * then recaptcha 2 fallback should be rendered inside <div id="recaptcha"></div>
     */
    const renderCaptcha2Fallback = () => {
        if(!window.grecaptcha) return;

        window.grecaptcha.ready(async () => {
            const widgetID = await renderRecaptcha2('recaptcha');
            setRecaptcha2WidgetID(widgetID);
        });
    };

    return (
        <div className="my-4">
            {
                isLoading &&
                <div style={{
                    margin: '7px 0',
                }}>
                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                </div>
            }
            {

                !isLoading  &&
                <>
                    {!ResultData && props.message !== '' && <div className="mb-2">{props.message}</div>}
                    {
                        /* ------------- google recaptcha version 2 or 3 ------------- */
                        !isChina &&
                        <div id="recaptcha" className={`mb-4 flex justify-center recaptcha recaptcha-version-${ recaptchaVersion }`}/>
                    }

                    {
                        /* ------------- china simple captcha ------------- */
                        isChina &&
                        <ChinaCaptchaField
                            control={ simpleCaptchaCode }
                            setSimpleCaptchaCode={ setSimpleCaptchaCode }
                            simpleCaptchaAttempts={ simpleCaptchaAttempts }
                        />
                    }
                    {
                        captchaError &&
                        <div className="text-sm text-red my-4 text-center" data-id={ recaptcha2WidgetID }>{ captchaError }</div>
                    }



                    {(!ResultData || ResultData.resultObjectType !== "CANCELRSVP_SUCCESS") && <div>
                        <button type="button" className="w-btn p-4"
                                onClick={evt => {
                                    cancelReg();
                                }}>CANCEL NOW</button>
                    </div>}

                    {!ResultData?.resultStatus && ResultData?.message != null && ResultData?.message.toString() !== "" &&
                                <div className="mt-4 error-box" dangerouslySetInnerHTML={{ __html: ResultData?.message?.toString() }} />
                    }

                    {ResultData?.resultStatus && ResultData?.message != null && ResultData?.message.toString() !== "" &&
                        <div className="mt-4 ok-box" dangerouslySetInnerHTML={{ __html: ResultData?.message?.toString() }} />
                    }
                    {
                        !isChina && recaptchaVersion === 3 &&
                        <div className="mt-4 text-center">
                            <Recaptcha3Text />
                        </div>
                    }
                </>
            }

        </div>
    )
};

export default EventsCancelApp;